<template>
  <div class="container">
    <div
      v-wechat-title="($route.meta.title = info.ContactName + '的名片')"
    ></div>
    <div class="topBox">
      <div class="mcb_item">
        <img src="../../../static/images/index/nc_bg01.png" class="mcbi_bg" />
        <van-image
          fit="cover"
          :src="info.Photo"
          round
          error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
        ></van-image>
        <div class="mcbi_top">
          <div class="name">{{ info.ContactName }}</div>
          <div>{{ info.Duty }}</div>
          <div style="margin-top: 17px">
            <span class="iconfont icon-phone"></span>{{ info.Mobile }}
          </div>
          <div style="margin-top: 7px">
            <span class="iconfont icon-email-fill"></span>{{ info.Email }}
          </div>
        </div>
        <div class="mcbi_btm">
          <div class="company overFlowTwo">{{ info.CompanyName }}</div>
          <div class="overFlowTwo">{{ info.FullAddress }}</div>
        </div>
      </div>
      <div class="business" v-if="info.MainSupply">
        <div>业务范围</div>
        <div>{{ info.MainSupply }}</div>
      </div>
    </div>

    <div class="classifyNav" :style="info.MainSupply ? '' : 'margin-top:10px;'">
      <van-tabs
        type="line"
        v-model="type"
        title-active-color="#d62f2f"
        line-width="32px"
        line-height="5px"
        @change="typeClick(info.BusinessMemberId)"
        swipeable
        custom-class="vanTabs"
      >
        <van-tab title="TA的动态"></van-tab>
        <div v-if="info.MemberID > 0">
          <van-tab title="TA的公司展厅"></van-tab>
        </div>
      </van-tabs>
    </div>

    <!-- 动态列表 -->
    <div v-if="delay">
      <div class="listBox">
        <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="getListHandle"
        >
          <dynamic-list :list="list"></dynamic-list>
        </van-list>
        <div class="noDataBox" v-if="list.length == 0">
          <span class="iconfont icon-kong"></span>
          <div>什么也没有！</div>
        </div>
      </div>
    </div>

    <!-- 操作栏 -->
    <div class="operateBox">
      <div @click="deleteHandle(info.ContactID)">
        <span class="iconfont icon-trash"></span>
        <div>删除</div>
      </div>
      <div>
        <span class="iconfont icon-dianhua"></span>
        <a style="color: #333" :href="'tel:' + info.Mobile">打电话</a>
      </div>
      <div @click="copyClick">
        <span class="iconfont icon-copy"></span>
        <div>复制微信号</div>
      </div>
      <div @click="shareHandle">
        <span class="iconfont icon-share1"></span>
        <div>转发</div>
      </div>
    </div>

    <!--转发-->
    <div class="shareLayer" v-show="showLayer" @click="showLayer = false">
      <img src="../../../static/images/index/layer.png" />
    </div>
    <van-overlay v-show="showLayer" @click="showLayer = false"></van-overlay>
  </div>
</template>
<script>
import { getShareData } from "@/utils/share";
import DynamicList from "@/components/dynamicList";
import {
  memberBusinessContactInfo,
  memberPostList,
  memberBusinessContactByFolders,
} from "@/api/index";
import { Tabs, Tab, Image, List, Overlay, Col, Row, Icon } from "vant";
export default {
  name: "postcardDetail",
  components: {
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-image": Image,
    "van-list": List,
    "van-overlay": Overlay,
    "van-col": Col,
    "van-row": Row,
    "van-icon": Icon,
    DynamicList,
  },
  data() {
    return {
      type: 0,
      info: {},
      showLayer: false,

      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      list: [],

      delay: false,
    };
  },
  methods: {
    //分享好友
    shareHandle() {
      this.showLayer = true;
    },

    //tab切换
    typeClick(bid) {
      this.$router.push({ path: "/storeShow", query: { mid: bid } });
    },

    //获取名片详情
    getDetail() {
      var that = this;
      var data = {
        ContactID: that.$route.query.id,
      };
      memberBusinessContactInfo(data).then((res) => {
        that.info = res.Data;
        that.getListHandle(res.Data.BusinessMemberId);
        getShareData(
          window.location.href,
          res.Data.ContactName + "的名片，快来看看呀",
          "",
          res.Data.ShareImg
        );
      });
    },

    //获取动态列表
    getListHandle(businessMemberId) {
      var that = this;
      var data = {
        MemberId: businessMemberId,
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
      };
      memberPostList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.delay = true;
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //删除名片夹名片
    deleteHandle(id) {
      var that = this;
      memberBusinessContactByFolders({ ContactID: id }).then((res) => {
        that.Common.confirmDialog("确定删除名片吗？", function () {
          that.$router.push("/myPostcard");
        });
      });
    },

    //复制微信号
    copyClick() {
      if (this.info.WeiXin) {
        this.$copyText(this.info.WeiXin).then(
          (e) => {
            this.$toast.success("复制成功");
          },
          (e) => {
            this.$toast.fail("复制失败");
          }
        );
      } else {
        this.$toast("没有微信号!");
      }
    },
  },

  mounted() {
    this.getDetail();
  },
};
</script>
<style lang="less" scoped>
.container {
  padding: 20px 0 50px 0;
  .topBox {
    margin: 0 12px;
    .mcb_item {
      border-radius: 20px;
      position: relative;
      height: 230px;
      margin-top: 16px;
      padding: 0 25px;
      box-sizing: border-box;
      color: #333333;
      font-size: 13px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &:first-child {
        margin-top: 0px;
      }
      .mcbi_bg {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        width: 100%;
        height: 100%;
      }
      .van-image {
        display: block;
        width: 70px;
        height: 70px;
        position: absolute;
        top: 32px;
        right: 25px;
      }

      .mcbi_top {
        width: 225px;
        div {
          display: flex;
          align-items: center;
          line-height: 18px;
        }
        .name {
          font-weight: bold;
          color: #000000;
          font-size: 20px;
          line-height: 21px;
          margin-bottom: 6px;
          padding-top: 7px;
        }
        .iconfont {
          color: #5e8ae3;
          font-size: 12px;
          line-height: 12px;
          margin-right: 10px;
        }
      }
      .mcbi_btm {
        margin-top: 15px;
        div {
          margin-top: 5px;
        }
        .company {
          font-size: 15px;
          font-weight: bold;
          line-height: 18px;
        }
      }
    }
    .business {
      background-color: #5e8ae3;
      font-size: 12px;
      line-height: 18px;
      color: #fff;
      position: relative;
      z-index: -2;
      top: -25px;
      border-radius: 0px 0px 20px 20px;
      padding: 47px 24px 24px 24px;
      div {
        &:first-child {
          font-weight: bold;
          margin-bottom: 25rpx;
        }
      }
      &::before {
        content: "";
        display: block;
        position: absolute;
        z-index: -50;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
        box-shadow: 0px 0px 17px #5e8ae3;
        width: 277px;
        height: 50px;
      }
    }
  }
  .classifyNav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    margin-top: 0px !important;
    /deep/.van-tab {
      flex: inherit !important;
      -webkit-flex: inherit !important;
      width: 120px !important;
      font-size: 14px !important;
    }
    /deep/.van-tab--active {
      font-weight: bold;
    }
    /deep/.van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
      border-width: 0px;
    }
  }

  .operateBox {
    border-top: 1px solid #dddddd;
    background-color: #fff;
    display: flex;
    align-items: center;
    height: 50px;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    div {
      flex: 1;
      color: #000000;
      font-size: 11px;
      line-height: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .iconfont {
      font-size: 18px;
      line-height: 18px;
      margin-bottom: 8px;
    }
  }
}
</style>